import { Component } from '@angular/core';
import { CacLoginFormComponent } from '@controladad/ng-base';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [
    CacLoginFormComponent
  ],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
})
export class LoginComponent {
  logo = {
    url: '/assets/panel/images/lawazem-logo.jpg',
    alt: 'Lawazem Logo'
  };
}
